
<template>
<div id="jinfmcourse">

        <!-- maim -->
          <main class="main">
            <div class="bredcumb">
                <div class="container">
                    <ul>
                        <li><router-link to="/index"><a href="/index">首頁</a></router-link></li>
                        <li><router-link to="/channel/list"><a href="/channel/list">鯨選課程</a></router-link></li>
                        <li>{{this.title}}</li>
                    </ul>
                </div>
            </div>

            <div class="course_head">
                
                <div class="container">
                    <div class="wrapper">
                        <h1>{{this.title}}</h1>
                        <p>{{this.subtitle}}</p>
                        <ul class="info">
                            <li class="cost">{{this.total}}集 /{{this.products_points}}</li>
                            <li class="launchDate"><span>上架時間</span>{{this.publishedTime}}</li>
                        </ul>
                        <ul class="share">
                            <!-- <div class="fb"  data-layout="button_count" data-size="small" data-mobile-iframe="true"><a v-bind:href="shareURL" class="fb-xfbml-parse-ignore">分享</a></div> -->

                            <social-sharing  :url= this.pageUrl
                                                title= ''
                                                description= ''
                                                quote= ''
                                                hashtags=""
                                                twitter-user="vuejs"
                                                inline-template>   

                                 <network network="facebook">
                                    <li class="fb">
                                    <a href="">分享</a>
                                    </li>                
                                </network>
                        </social-sharing>

                           

                            <social-sharing :url= this.pageUrl
                                                    title=""
                                                    :description = this.lineShareValue
                                                    quote=""
                                                    hashtags=""
                                                    twitter-user="vuejs"
                                                    inline-template>      
                                 <network network="line">
                                    <li class="line">
                                    <a href="">分享</a>
                                    </li>                
                                </network>
                        </social-sharing>      

                        <li class="others"><a v-bind:href="QRCodeValue">在 App 開啟</a></li>
                        

                        </ul>
                    </div>
                </div>
                <div class="image"><img v-bind:src="imgCover"></div>
            </div>
            <div class="bodyContent">
                <div class="container">
                  <div v-if="publisher!=null" class="publisher"><p v-html="publisher"></p></div>
                  <section class="uploadArea intro">
                      <h2>課程簡介</h2>
                       <span v-html="description"></span>
                        <!-- <div>
                            <p>
                                0-3 歲的寶寶身體就算不舒服，也往往只能用哭鬧的方式表達，許多新手父母除了聽從長輩親友的建議之外，就是透過網路搜尋相關文章。但是網路文章內容參差不齊、作者是否具備醫療背景以及專業知識、觀點是否為醫界普遍認同都不能保證，也造成許多父母的困擾。
                            </p>
                            <p>
                                <div class="video-container">
                                    <iframe src="https://www.youtube.com/embed/8QOnBFFWDU0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                                </div>
                            </p>
                            <p>
                                在這裡，有 20 年經驗的臺北榮民總醫院小兒過敏感染科陳俊仁主治醫師作為你照顧寶寶的專門顧問，正確的養育觀念到寶寶的食、衣、住、行問題都會細細分享，「讓寶寶健康快樂的長大」大」是陳俊仁醫師與《一刻鯨選》團隊希望透過一系列內容給你與寶寶最大的禮物。
                            </p>
                        </div> -->
                    </section>
                    <section class="demo" v-show="checkAuditionVideosList">
                        <h2>試聽內容</h2>
                        <ul>
                           <li v-for = "audition_videos in audition_videos_list">
                                <!-- <div v-show="false"> {{youtube_url = youtube_url+ audition_videos.video}}</div> -->
                                <!-- <div v-if="isMobile"> -->
                                    <p v-if="isMobile"><a  target="_blank" v-bind:href="youtube_url+ audition_videos.video" class="playBtn">播放</a></p>
                                <!-- </div> -->

                                <!-- <div  v-else> -->
                                    <p v-if="!isMobile"><a v-bind:href="youtube_url+ audition_videos.video" class="playBtn glightbox3">播放</a></p>

                                <!-- </div> -->
                                    <p>{{audition_videos.title}}</p>

                           </li>
                     
                            
                        </ul>
                    </section>
                   
                    <section class="uploadArea">
                        <!-- <h2>分集大綱</h2> -->
                        <div class="moreOrLess">
                            
                           <span v-html="descriptionHtml"></span>
                           
                        </div>
                    </section>
                    
                     <section class="courseTutor">
                        <h2>主講人</h2>
                        <div class="wrapper">
                            <div class="image"><img v-bind:src="author_imgAvatar" ></div>
                            <div class="intro">
                                <strong>{{this.author_title}}</strong>
                                <div>


                                    <span v-html="author_description"></span>

                                </div>
                            </div>
                        </div>
                    </section>
                    <!-- <section>
                        <h2>適合對象</h2>
                        <ul class="listLineStyle">
                           <span v-html="target"></span>
                        </ul>
                    </section> -->
                    <section class="qrcode_course">
                        <div class="wrapper">
                            <div class="box">
                                <!-- <figure><img src="@/assets/images/global_qrcode.png" alt="課程QRcode"></figure>
                                <figcaption>下載<b>一刻鯨選</b>收聽完整課程！</figcaption> -->
                                  <qrcode-vue :value="QRCodeValue" :size="125" level="H"></qrcode-vue>
                                  <figcaption>下載<b>一刻鯨選</b>收聽完整課程！</figcaption> 
                            </div>
                            
                        </div>
                    </section> 
                    <section class="relatedCourse" v-show="checkRelatedChannelsList">
                        <h2>相關課程</h2>
                        <div class="wrapper">
                            <ul class="slick_list course_style2">
                                    
                                 <li v-for="(related_channels,$index) in related_channels_list"  @click="channelClickListener (related_channels, $index)" >

                                    <figure>
                                        <div class="graphic"><img v-bind:src="related_channels.imgCover"></div>
                                        
                                    </figure>
                                    <figcaption>
                                        <h3>{{related_channels.title}}</h3>
                                        <b>{{related_channels.author.title}}</b>
                                    </figcaption>
                                    <a :href="'/channel/'+related_channels.id" class="fullLink"></a>
                                    <!-- <a href="" class="fullLink" >詳細內容</a> -->
                                </li>


                                <!-- <li>
                                    <figure>
                                        <div class="graphic"><img src="@/assets/images/sample/course_2.jpg"></div>
                                    </figure>
                                    <figcaption>
                                        <h3>經理的面具：掌握管理的情境</h3>
                                        <b>葉匡時</b>
                                    </figcaption>
                                    <a href="#" class="fullLink" title="經理的面具：掌握管理的情境">詳細內容</a>
                                </li>
                                <li>
                                    <figure>
                                        <div class="graphic"><img src="@/assets/images/sample/course_2.jpg"></div>
                                    </figure>
                                    <figcaption>
                                        <h3>經理的面具</h3>
                                        <b>葉匡時</b>
                                    </figcaption>
                                    <a href="#" class="fullLink" title="經理的面具：掌握管理的情境">詳細內容</a>
                                </li>
                                <li>
                                    <figure>
                                        <div class="graphic"><img src="@/assets/images/sample/course_2.jpg"></div>
                                    </figure>
                                    <figcaption>
                                        <h3>經理的面具：掌握管理的情境</h3>
                                        <b>葉匡時</b>
                                    </figcaption>
                                    <a href="#" class="fullLink" title="經理的面具：掌握管理的情境">詳細內容</a>
                                </li>
                                <li>
                                    <figure>
                                        <div class="graphic"><img src="@/assets/images/sample/course_2.jpg"></div>
                                    </figure> 
                                    <figcaption>
                                        <h3>經理的面具：掌握管理的情境</h3>
                                        <b>葉匡時</b> 
                                    </figcaption>  
                                    <a href="#" class="fullLink" title="經理的面具：掌握管理的情境">詳細內容</a>
                                </li>
                                <li>
                                    <figure>
                                        <div class="graphic"><img src="@/assets/images/sample/course_2.jpg"></div>
                                    </figure>
                                    <figcaption>
                                        <h3>經理的面具：掌握管理的情境</h3>
                                        <b>葉匡時</b>
                                    </figcaption>
                                    <a href="#" class="fullLink" title="經理的面具：掌握管理的情境">詳細內容</a>
                                </li>
                                <li>
                                    <figure>
                                        <div class="graphic"><img src="@/assets/images/sample/course_2.jpg"></div>
                                    </figure>
                                    <figcaption>
                                        <h3>經理的面具：掌握管理的情境</h3>
                                        <b>葉匡時</b>
                                    </figcaption>
                                    <a href="#" class="fullLink" title="經理的面具：掌握管理的情境">詳細內容</a>
                                </li> -->
                            </ul>
                        </div>
                        
                    </section>
                    <!-- <section>
                        <h2>相關文章</h2>
                        <ul class="listPureLink">
                            <li><a href="#">咖啡，文學與鯨──你知道星巴克的意思嗎？</a></li>
                            <li><a href="#">說話不是為了表現自己，是為了被需要地傾聽</a></li>
                        </ul>
                    </section> -->
                </div>
            </div>
        </main>

</div>
</template>


<script>
import GLightbox from "glightbox";
import slick from "@/assets/vendor/slick/slick.min.js";
import readmore from "@/assets/vendor/readmore/readmore.min.js";
import functionJs from "@/assets/js/function.js";
import pace from "@/assets/vendor/pace/js/pace.min.js";

//let glightbox = require('@/assets/vendor/glightbox-master/glightbox.min.js')
import QrcodeVue from 'qrcode.vue';

export default {
        name: 'async',
    metaInfo () {

      return {
          
        
        title: this.title +' | 課程 | 一刻鯨選',
        meta: [
            // OpenGraph data (Most widely used)
            {property: 'og:title', content: this.title +'| 課程 | 一刻鯨選'},
            {property: 'og:site_name', content: this.title +'| 課程 | 一刻鯨選'},
            // The list of types is available here: http://ogp.me/#types
            {property: 'og:type', content: 'website'},
            // Should the the same as your canonical link, see below.
            {property: 'og:url', content: window.location.toString()},
            {property: 'og:image', content: this.imgCover},
            // Often the same as your meta description, but not always.
            {property: 'og:description', content: this.meta_description},

        
        ]
      }
    },
 
  afterRouteEnter  (to, from, next) {
      
      to.$forceUpdate();
      
      
    // react to route changes...
     next()
  },
//   metaInfo: {
//     title: "Course", // set a title
//     meta: [
//       {
//         // set meta
//         name: "Course",
//         content: "Course"
//       }
//     ],
//     link: [
//       {
//         // set link
//         rel: "asstes",
//         href: "https://testfront.jinfm.net/index"
//       }
//     ]
//   },

  data() {
    return {
      classData: [],
      title: "", //標題
      subtitle: "", //副標題
      imgCover: "", //圖片
      description: "", //描述
      meta_description: "", //描述(meta用)

      descriptionHtml: "", //描述HTML
      target: "", //適合對象
      total: "", //總課堂數
      publishedTime: "", //出版時間，UTC時間
      episode_counts: "", //音頻數量
      author: [], //作者
      author_title: "", //作者標題
      author_imgAvatar: "", //作者圖片
      author_description: "", //作者描述
      episodesList: [], //音頻
      episodes_title: "", //音頻標題
      episodes_summary: "", //音頻大綱
      episodes_publishedTime: "", //音頻出版時間，UTC時
      index_str: "0",
      audition_videos_list: [], //試聽影音
      related_channels_list: [], //相關課程
      products_points: "", //銷售方案點數
      publisher:"",//出版方
      youtube_url: "https://www.youtube.com/watch?v=",
      id : "0",
      shareURL: '',
      checkRelatedChannelsList : true,
      checkAuditionVideosList : true,
      QRCodeValue:'',
      pageUrl:'',
      lineShareValue:'',
      isMobile:false,
    };
  },
  

  created() {
     

    // this.QRCodeValue ='https://jinfm.page.link/?link='+window.location.toString()+'&apn=net.jinfm&isi=1374244242&ibi=net.jinfm&ius=jinfm&st=一刻鯨選&sd=好知識就在耳邊',
   this.pageUrl =  window.location.toString();
   if(this.pageUrl.includes("?")){
    this.pageUrl = this.pageUrl.split('?')[0];
   }
   this.QRCodeValue ='https://jinfm.page.link/?link='+ this.pageUrl+'&apn=net.jinfm.app&isi=1440248584&ibi=net.jinfm.app&ius=jinfm';
   

    this.id = window.location.toString();
    this.shareURL =  'https://www.facebook.com/sharer/sharer.php?u='+window.location.toString();

    var index = this.id.lastIndexOf("/");

    this.id = this.id.substring(index + 1, this.id.length);

    this.axios
      .get(this.$store.getters.baseURL + "channels/" + this.id)
      .then(response => {
        this.classData = response.data;
        this.imgCover = this.classData.imgCover;
        this.total = this.classData.total;
        this.publishedTime = this.classData.publishedTime;
        this.imgCover = this.classData.imgCover;
        this.author = this.classData.author;
        this.episode_counts = this.classData.episode_counts;
        this.author = this.classData.author;
        this.author_imgAvatar = this.author.imgAvatar;
        this.episodesList = this.classData.episodes;
        this.audition_videos_list = this.classData.audition_videos;
        this.related_channels_list = this.classData.related_channels;

        if(this.related_channels_list.length ==0){
            this.checkRelatedChannelsList = false;
        }
        if(this.audition_videos_list.length ==0){
            this.checkAuditionVideosList = false;
        }
        if(this.classData.products.length ==0){
        this.products_points = '免費';
        }else{
         this.products_points = this.classData.products[0].points+'點';
        }
        this.getTW();
        this.setTime();
        this.meta_description = this.strip_html_tags(this.meta_description);
         this.lineShareValue = '【一刻鯨選】'+this.title +'\n'+'' ;

           //ga
       if(this.title != ''){
        this.$ga.page({
            page: '/channel/'+ this.id,
            title: this.title +' | 課程 | 一刻鯨選',
            location: window.location.href
            })
        }
      })
      .catch(error => console.log("log:" + error));


      
          
  },

//   metaInfo: {
//  title: '課程 | 一刻鯨選', // set a title
//   meta: [
//             // OpenGraph data (Most widely used)
//             {property: 'og:title', content: '| 課程 | 一刻鯨選'},
//             {property: 'og:site_name', content: this.title +'| 課程 | 一刻鯨選'},
//             // The list of types is available here: http://ogp.me/#types
//             {property: 'og:type', content: 'website'},
//             // Should the the same as your canonical link, see below.
//             {property: 'og:url', content: window.location.toString()},
//             {property: 'og:image', content: 'https://testfront.jinfm.net/static/img/logo.05d3c53.png'},
//             // Often the same as your meta description, but not always.
//             {property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！'},

//             // // Twitter card
//             // {name: 'twitter:card', content: 'summary'},
//             // {name: 'twitter:site', content: 'https://www.my-site.com/my-special-page'},
//             // {name: 'twitter:title', content: 'My Page Title ← My Site'},
//             // {name: 'twitter:description', content: 'I have things here on my site.'},
//             // // Your twitter handle, if you have one.
//             // {name: 'twitter:creator', content: '@alligatorio'},
//             // {name: 'twitter:image:src', content: 'https://www.my-site.com/my-special-image.jpg'},

//             // // Google / Schema.org markup:
//             // {itemprop: 'name', content: 'My Page Title ← My Site'},
//             // {itemprop: 'description',content: 'I have things here on my site.'},
//             // {itemprop: 'image', content: 'https://www.my-site.com/my-special-image.jpg'}
//         ]
//     },
  updated() {


//       history.listen((location) => {
//     if (window.ga) {
//         window.ga('send', 'pageview', this.title +'| 課程 | 一刻鯨選');
//     }
// });
//      //判斷是否手機
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if(isiOS == true || isAndroid == true){
        this.isMobile = true;
    }


   if (window.scrollY > 0 ) {
      $('html,body').animate({
       scrollTop: 0
       }, 'slow');

     }
      
    this.$nextTick(function() {
      var lightboxVideo = GLightbox({
        selector: "glightbox3"
      });

      $('.slick_list.course_style2').slick({
              infinite: true,
              arrows: false,
              dots: true,
              loop: true,
              slidesToShow: 4,
              slidesToScroll: 4,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 767,
                  settings: 'unslick'
                  
                }
              ] 
            });
    });

    $("#pagetop p").click(function() {
      $("html,body").animate({ scrollTop: 0 }, "slow");
      return false;
    });
  },
  methods: {

       strip_html_tags(str){
            {
            if ((str===null) || (str===''))
                return false;
            else
            str = str.toString();
            return str.replace(/<[^>]*>/g, '');
         }
     },

    changePage(page) {
      this.$router.push({ path: "/" + page });
    },
        channelClickListener (item, index) {
           let id = item.id;

        // alert(item.id);
// 　　　　 this.$router.push({ path: "/course" });
        // this.$store.commit('courseId', id)
        this.$router.push({ path: "/channel/"+id, params: { id } });
         window.location.reload()
         
　　　　},
    getTW() {
      this.title = this.classData.title;
      this.subtitle = this.classData.subtitle;
      this.description = this.classData.description;
      this.meta_description = this.classData.description;
      this.descriptionHtml = this.classData.descriptionHtml; 
      this.target = this.classData.target;
      this.author_title = this.author.title;
      this.author_description = this.author.descriptionHtml;
      this.publisher = this.classData.publisher
    },

    getCN() {
      this.title = this.classData.titleCN;
      this.subtitle = this.classData.subtitleCN;
      this.description = this.classData.descriptionCN;
      this.meta_description = this.classData.descriptionCN;
      this.descriptionHtml = this.classData.descriptionHtmlCN; 
      this.target = this.classData.targetCN;
      this.author_title = this.author.titleCN;
      this.author_description = this.author.descriptionHtmlCN;
      this.publisher = this.classData.publisherCN
     

    },
    clearIndex() {
      this.index_str = "0";
    },
    setTime() {
      this.publishedTime = this.publishedTime
        .substring(0, 10)
        .replace(new RegExp("-", "gm"), "/");
      this.episodes_publishedTime = this.episodes_publishedTime
        .substring(0, 10)
        .replace(new RegExp("-", "gm"), "/");
    },
    setYoutube(id) {
      this.youtube_url = this.youtube_url + id;
    }
  },

  components: {
    QrcodeVue
  },
  mounted() {
      $( "body" ).removeClass('index');

      setTimeout(() => {
                this.title = this.title
            }, 2000)
        
    $(".moreOrLess").readmore({
      moreLink: '<a class="readMore" href="#">顯示更多</a>',
      lessLink: '<a href="#">顯示更少</a>',
      collapsedHeight: 600,
      afterToggle: function(trigger, element, expanded) {
        if (!expanded) {
          // The "Close" link was clicked
          $("html, body").animate(
            { scrollTop: element.offset().top },
            { duration: 100 }
          );
        }
      }
    });

    $("article").readmore({ speed: 1000 });

    var length =
      $(".qrcode_course").height() -
      $(".qrcode_course .wrapper").height() +
      $(".qrcode_course").offset().top;

    $(window).scroll(function() {
      var scroll = $(this).scrollTop();
      var height = $(".qrcode_course .wrapper").height() + "px";

      if (scroll < $(".qrcode_course").offset().top) {
        $(".qrcode_course .wrapper").css({
          position: "absolute",
          top: "0"
        });
      } else if (scroll > length) {
        $(".qrcode_course .wrapper").css({
        //   position: "absolute",
        //   bottom: "0",
        //   top: "auto"
        });
      } else {
        $(".qrcode_course .wrapper").css({
          position: "fixed",
          top: "160px",
          height: height
        });
      }
    });
  }
};
</script>
<style>

</style>






// WEBPACK FOOTER //
// src/components/views/Course.vue